import { Column, TripleRingLoader } from 'components/Blocks';

function Validating() {
  return (
    <Column gap="8">
      <TripleRingLoader />

      <h5>Validating Document....</h5>
    </Column>
  );
}

export default Validating;
